// src/app/withRouter.js
import { useNavigate, useLocation, useParams } from "react-router-dom";

export function withRouter2(Component) {
  return (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Component {...props} router={{ navigate, location, params }} />;
  };
}
